import React, { useState, useContext } from 'react';
import {
  Button,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle,
  Typography,
} from '@one-thd/sui-atomic-components';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';
import { AppContext } from '@thd-nucleus/app-render';
import { RentalsServicesSkeleton } from '../subcomponents/Skeletons';
import { ShopAllCard } from './ShopAllCard';

const COLLAPSED_COUNT = 6;

const DetailedCard = ({ item }) => (
  <Card
    className="sui-h-full sui-w-full"
    CardContentProps={{ className: 'sui-flex sui-p-4 sui-gap-4 sui-flex-col sui-h-full' }}
  >
    <CardMedia
      src={item.imageUrl}
      alt={item.description}
      padding
      loading="lazy"
    />
    <CardTitle
      header={(
        <Typography variant="h3" weight="bold">
          {item.description}
        </Typography>
      )}
    />
    <div className="sui-flex-grow">
      <CardBody>
        <ul className="sui-list-disc sui-pl-4 sui-flex sui-flex-col sui-gap-1">
          {item.details.map((detail) => (
            <li key={detail}>
              <Typography variant="body-base">{detail}</Typography>
            </li>
          ))}
        </ul>
      </CardBody>
    </div>
    <CardActions position="center">
      <a
        href={`${item.link}?emt=ppsrc_2603`}
        rel={item.link?.includes('penske') ? 'nofollow' : undefined}
        className="sui-w-full hover:sui-no-underline"
      >
        <Button fullWidth variant="secondary">Check Availability</Button>
      </a>
    </CardActions>
  </Card>
);

const RentalDetailedGrid = ({ title, rentalItems, loading, error }) => {
  const { instance } = useContext(AppContext);
  const thdSeoBotDetected = instance?.thdSEOBotDetection;
  const [showAll, setShowAll] = useState(!!thdSeoBotDetected);

  if (loading) return <RentalsServicesSkeleton />;
  if (!rentalItems?.length || error) return null;

  const shouldCollapse = rentalItems.length > COLLAPSED_COUNT;
  const visibleItems = showAll ? rentalItems : rentalItems.slice(0, COLLAPSED_COUNT);

  return (
    <div className="sui-flex sui-flex-col sui-gap-4">
      <Typography variant="h2" weight="display">{title}</Typography>

      <div
        className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 lg:sui-grid-cols-3 sui-gap-6"
        style={{ maxWidth: '1100px' }}
      >
        {visibleItems.map((item, index) => (
          <React.Fragment key={item.link || `rental-${index}`}>
            {index === 0
              ? <ShopAllCard item={item} />
              : <DetailedCard item={item} />}
          </React.Fragment>
        ))}
      </div>

      {shouldCollapse && (
        <div className="sui-flex sui-items-center sui-justify-center">
          <Button
            variant="text"
            endIcon={showAll ? ArrowUp : ArrowDown}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'View Less' : 'View More'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default RentalDetailedGrid;